import { isPresent } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"
import ReactOnRails from "react-on-rails"

class PaginateCharges extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      isError: false,
      page: props.page || 1,
      pageSize: props.pageSize,
      totalRemaining: props.totalRemaining,
    }

    this.loadMore = this.loadMore.bind(this)
  }

  loadMore(event) {
    if (event) event.preventDefault()

    // Prevent loading if already loading or if we've loaded everything
    if (this.state.isLoading || this.state.totalRemaining === 0) {
      return
    }

    this.setState({
      isLoading: true,
      isError: false,
    })

    const newPage = this.state.page + 1
    $.post(this.props.paginateUrl, { page: newPage })
      .done((data) => {
        if (isPresent(data)) {
          this.setState({
            isLoading: false,
            page: newPage,
            pageSize: data.pageSize,
            totalRemaining: data.totalRemaining,
          })

          // Only append if we actually received new content
          if (isPresent(data.html) && data.html.trim() !== "") {
            $(this.props.htmlPath).append(data.html)

            // Initialize only the newly added React components
            const newRows = $(this.props.htmlPath)
              .find("tr")
              .slice(-data.pageSize)
            newRows.find("[data-react-class]").each(function () {
              const $el = $(this)
              const componentName = $el.data("react-class")
              const props = $el.data("react-props")
              const componentId = $el.attr("id")

              if (
                componentName &&
                props &&
                componentId &&
                !$el.data("react-initialized")
              ) {
                ReactOnRails.render(componentName, props, componentId)
                $el.data("react-initialized", true)
              }
            })
          }
        }
      })
      .fail(() => {
        this.setState({
          isLoading: false,
          isError: true,
        })
      })
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading more...</div>
    }

    if (this.state.isError) {
      return <div>Error loading more...refresh page and try again.</div>
    }

    if (this.state.totalRemaining === 0) {
      return null
    }

    if (this.state.totalRemaining > this.state.pageSize) {
      return (
        <span>
          {this.state.totalRemaining} earlier charges hidden.
          <a className="pl-3" href="#charges" onClick={this.loadMore}>
            Show remaining charges
          </a>
        </span>
      )
    }

    return (
      <span>
        {this.state.totalRemaining} earlier charges hidden.
        <a className="pl-3" href="#charges" onClick={this.loadMore}>
          Show {this.state.totalRemaining} more
        </a>
      </span>
    )
  }
}

PaginateCharges.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number.isRequired,
  totalRemaining: PropTypes.number.isRequired,
  paginateUrl: PropTypes.string.isRequired,
  htmlPath: PropTypes.string.isRequired,
}

export default PaginateCharges
